import initialState from "./initialState";

export const types = {
  SET_HISTORY: "SET_HISTORY",
  SET_GEO_DATA: "SET_GEO_DATA",
  reset: "reset",
};

export default {
  [types.SET_GEO_DATA]: (state, geoData) => {
    state.geoData = geoData;
    state.geoDataById = Object.keys(geoData);
  },
  [types.SET_HISTORY]: (state, history) => {
    state.history = history;
  },

  [types.reset]: state => {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};
